import { useUserConfig } from "hooks/useUserConfig";
import { TransformedFeatureConfig, FeatureUIBehavior } from "types";
import * as FeatureFlags from "helpers/constants/filters";

export interface FeatureFlagResult {
  show: boolean;
  enabled: boolean;
  reason?: string;
}

type FeatureFlagKeys = (typeof FeatureFlags)[keyof typeof FeatureFlags];

/**
 * Custom hook for managing feature flags for single dataset context.
 * @param featureKey - The feature key to check
 * @returns FeatureFlagResult with show and enabled boolean properties
 */
export function useFeatureFlagService(
  featureKey: FeatureFlagKeys,
): FeatureFlagResult {
  const userConfig = useUserConfig();

  // Get backend enabled value
  const config: TransformedFeatureConfig | undefined = userConfig?.config?.find(
    (cfg) => cfg.feature_key === featureKey,
  );

  // Fallback to backend config for production
  if (config) {
    const behavior: FeatureUIBehavior | null | undefined =
      config.feature_behavior["ANY"];
    if (behavior) {
      return {
        reason: config.reason,
        enabled: behavior === "SHOW",
        show: behavior === "SHOW" || behavior === "GREY_OUT",
      };
    }
  }

  return { enabled: false, show: false };
}
